import { addListener, createListenerMiddleware } from '@reduxjs/toolkit'

import { AppDispatch } from '@/config/store/store'
import { RootState } from '@/ducks/root.reducer'

export const listenerMiddleware = createListenerMiddleware()

// for inital listener
export const startAppListening = listenerMiddleware.startListening.withTypes<
  RootState,
  AppDispatch
>()

// for adding new listener in runtime
export const addAppListener = addListener.withTypes<RootState, AppDispatch>()
